import * as React from 'react';

var useEventListener = function useEventListener(_ref) {
  var eventName = _ref.eventName,
    handler = _ref.handler,
    _ref$attached = _ref.attached,
    attached = _ref$attached === void 0 ? true : _ref$attached,
    _ref$capture = _ref.capture,
    capture = _ref$capture === void 0 ? true : _ref$capture,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? typeof window !== 'undefined' ? window : null : _ref$element;
  var registeredListener = React.useRef(null);
  React.useEffect(function () {
    var options = {
      capture: capture
    };
    var wrappedHandler = function wrappedHandler(event) {
      handler(event);
    };
    if (attached && element) {
      if (!registeredListener.current) {
        element.addEventListener(eventName, wrappedHandler, options);
        registeredListener.current = {
          eventName: eventName,
          handler: wrappedHandler,
          options: options
        };
      }
    }
    return function () {
      if (element && registeredListener !== null && registeredListener !== void 0 && registeredListener.current) {
        element.removeEventListener(registeredListener.current.eventName, registeredListener.current.handler, registeredListener.current.options);
        registeredListener.current = null;
      }
    };
  }, [eventName, handler, element, attached, capture]);
};

export { useEventListener };
//# sourceMappingURL=useEventListener.js.map
